export default "__VITE_ASSET__Cjx31iim__"